import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AreaChart, Area, XAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { collection, query, getDocs, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { useParams } from 'react-router-dom';

function Chart({ aspect, title }) {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const [fweek, setFWeek] = useState(null);
  const [sweek, setSWeek] = useState(null);
  const [tweek, setTWeek] = useState(null);
  const [lweek, setLWeek] = useState(null);
  const [jnamount, setJNAmount] = useState(null);
  const [jlamount, setJLAmount] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  const [lastMonth, setLastMonth] = useState(null);
  const { userId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      const today = new Date();

      const lastMonth = new Date(new Date().setMonth(today.getMonth() - 1));
      setCurrentMonth(monthNames[today.getMonth()]);
      setLastMonth(monthNames[today.getMonth() - 1]);

      const firstWeek = new Date(new Date().setDate(today.getDay() - 28));
      const secondWeek = new Date(new Date().setDate(today.getDay() - 21));
      const thirdWeek = new Date(new Date().setDate(today.getDay() - 14));

      const lastWeek = new Date(new Date().setDate(today.getDay() - 7));
      const twoMonth = new Date(new Date().setMonth(today.getMonth() - 2));

      const lastMonthQuery = query(
        collection(db, 'users', userId, 'photos'),
        where('timeStamp', '<=', today),
        where('timeStamp', '>', lastMonth)
      );
      const twoMonthQuery = query(
        collection(db, 'users', userId, 'photos'),
        where('timeStamp', '<=', lastMonth),
        where('timeStamp', '>', twoMonth)
      );

      const firstWeekQuery = query(
        collection(db, 'users', userId, 'photos'),
        where('timeStamp', '<=', secondWeek),
        where('timeStamp', '>', firstWeek)
      );
      const secondWeekQuery = query(
        collection(db, 'users', userId, 'photos'),
        where('timeStamp', '<=', thirdWeek),
        where('timeStamp', '>', secondWeek)
      );

      const thirdWeekQuery = query(
        collection(db, 'users', userId, 'photos'),
        where('timeStamp', '<=', lastWeek),
        where('timeStamp', '>', thirdWeek)
      );
      const lastWeekQuery = query(
        collection(db, 'users', userId, 'photos'),
        where('timeStamp', '<=', today),
        where('timeStamp', '>', lastWeek)
      );

      const lastMonthData = await getDocs(lastMonthQuery);
      const twoMonthData = await getDocs(twoMonthQuery);
      const firstWeekData = await getDocs(firstWeekQuery);
      const secondWeekData = await getDocs(secondWeekQuery);
      const thirdWeekData = await getDocs(thirdWeekQuery);
      const lastWeekQueryData = await getDocs(lastWeekQuery);

      setJLAmount(lastMonthData.docs.length);
      setJNAmount(twoMonthData.docs.length);

      setFWeek(firstWeekData.docs.length);
      setSWeek(secondWeekData.docs.length);
      setTWeek(thirdWeekData.docs.length);
      setLWeek(lastWeekQueryData.docs.length);
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  const data = [
    {
      name: lastMonth,
      Total: jnamount,
    },
    {
      name: 'First Week',
      Total: fweek,
    },
    {
      name: 'Second Week',
      Total: sweek,
    },
    {
      name: 'Third Week',
      Total: tweek,
    },
    {
      name: currentMonth,
      Total: jlamount,
    },
    {
      name: 'Last Week',
      Total: lweek,
    },
  ];

  return (
    <ChartStyled>
      <h1 className="title">{title}</h1>
      <ResponsiveContainer width="100%" aspect={aspect}>
        <AreaChart width={730} height={250} data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="total" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#7199ff" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#7199ff" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" stroke="gray" />
          <CartesianGrid strokeDasharray="3 3" className="chart-grid" />
          <Tooltip />
          <Area type="monotone" dataKey="Total" stroke="#8884d8" fillOpacity={1} fill="url(#total)" />
        </AreaChart>
      </ResponsiveContainer>
    </ChartStyled>
  );
}

const ChartStyled = styled.div`
  flex: 4;
  padding: 10px;
  -webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.4);
  box-shadow: 2px 4px 10px 1px rgba(201, 201, 201, 0.4);
  color: var(--accent-blue);

  .title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    color: var(--accent-blue);
  }

  .chart-grid {
    stroke: rgb(228, 255, 255);
  }
`;

export default Chart;
